/** @format */
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import store from "./store";
import Validate from "./components/validate-user";
import { AwsRum } from "aws-rum-web";
import { initReplay } from "./sessionReplay";

let awsRum;

try {
  const rumConfig = {
    sessionSampleRate: 1,
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    // No "replay" telemetry: session replay is @jobtarget/browser-rum's job, and
    // two DOM recorders in one document both patch fetch, XHR and console.
    telemetries: [
      "performance",
      "errors",
      [
        "http",
        {
          // Without this a request is recorded but linked to nothing on the
          // backend, so the RUM console's Traces column stays empty.
          addXRayTraceIdHeader: true,
          recordAllRequests: true,
          // aws-rum-web matches the URL as the caller wrote it, so an
          // absolute-only pattern traces nothing for relative fetches.
          urlsToInclude: [/^\/(?!\/)/, /^https?:\/\/[^/?#]*\.jobtarget\.com([/:?#]|$)/],
          // The replay intake is a *.jobtarget.com host, so the include pattern
          // catches it: RUM would instrument the recorder's own uploads, one
          // billable event and one X-Ray segment per chunk.
          urlsToExclude: [/rum-replay-intake\.jobtarget\.com/],
        },
      ],
    ],
    allowCookies: true,
    // Turned on with the trace header above: without X-Ray a traced request has
    // nowhere to land.
    enableXRay: true,
  };

  awsRum = new AwsRum(
    process.env.REACT_APP_RUM_APP_MONITOR_ID,
    // The release, not "1.0.0": a literal says nothing about which deploy is live.
    process.env.REACT_APP_APP_RELEASE || process.env.REACT_APP_VERSION || "",
    process.env.REACT_APP_RUM_REGION || "us-east-1",
    rumConfig
  );
  // Join the two: the replay SDK pins its session id onto the RUM session, so the
  // console's CloudWatch RUM deep links resolve.
  import("@jobtarget/browser-rum").then(({ registerCloudWatchRum }) =>
    registerCloudWatchRum(awsRum),
  );
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

// Session replay. Started here, beside the RUM client, because this module is the
// app's entry and the recorder wraps fetch, XHR and console as it starts.
initReplay();

// Link the user information to the logged in user
window.dispatchEvent(new CustomEvent("requestuserinfo:jt:navbar"));
window.addEventListener("userinfo:jt:navbar", event => {
  if (awsRum) {
    awsRum.addSessionAttributes({
      userId: event.detail.user_id,
      companyName: event.detail.company.companyName,
    });
  }
});

function App() {
  console.log("version 1.0.1");
  // Root component.
  // use to handle HomePage and fallback 404 page.

  // 9/27 revision - removed route to Homepage and Validate renders HomePage after

  return (
    <Provider store={store}>
      <>
        <Router>
          <Route exact path="/" component={Validate} />
        </Router>
      </>
    </Provider>
  );
}

export default App;
